import { useState } from "react";

const ItemCount = ({ stock, onAdd }) => {
  const [quantity, setQuantity] = useState(1); // 👈 arranca en 1, no en 0

  const increment = () => {
    if (quantity < stock) setQuantity(prev => prev + 1);
  };

  const decrement = () => {
    if (quantity > 1) setQuantity(prev => prev - 1);
  };

  return (
    <div className="flex flex-col items-center mt-4 space-y-3">
      <div className="flex items-center space-x-4">
        <button
          type="button"
          onClick={decrement}
          className="text-white bg-gradient-to-br from-pink-500 to-orange-400 hover:opacity-90 focus:ring-4 focus:outline-none focus:ring-pink-200 font-medium rounded-full text-xl px-5 py-2.5 text-center cursor-pointer active:scale-95 transition-transform"
        >
          -
        </button>

        <h4 className="text-lg font-semibold select-none">{quantity}</h4>

        <button
          type="button"
          onClick={increment}
          className="text-white bg-gradient-to-br from-pink-500 to-orange-400 hover:opacity-90 focus:ring-4 focus:outline-none focus:ring-pink-200 font-medium rounded-full text-xl px-5 py-2.5 text-center cursor-pointer active:scale-95 transition-transform"
        >
          +
        </button>
      </div>

      <button
        type="button"
        onClick={() => onAdd(quantity)}
        disabled={!stock}
        className="bg-black text-white px-5 py-2 rounded-md hover:bg-gray-800 active:scale-95 transition-transform"
      >
        Agregar al carrito
      </button>
    </div>
  );
};

export default ItemCount;
